/* ScandyLand pick & mix.
   Every piece costs the same, so the mix enters the cart as ONE line of the
   mix-piece product with quantity = total pieces, and the contents ride along
   as a line-item property. If pieces ever need different prices, this has to
   become one line per candy instead.
   Touch devices never fire HTML5 drag events, so tapping a tile is the primary
   input and dragging is the enhancement. */
(function () {
  function init(root) {
    var shelf = root.querySelector('[data-shelf]');
    var bag = root.querySelector('[data-bag]');
    var listEl = root.querySelector('[data-list]');
    var emptyEl = root.querySelector('[data-empty]');
    var addBtn = root.querySelector('[data-add]');
    var countEl = root.querySelector('[data-total-count]');
    var priceEl = root.querySelector('[data-total-price]');
    var meterEl = root.querySelector('[data-meter]');
    var noteEl = root.querySelector('[data-note]');
    if (!shelf || !bag) return;

    var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
    var minP = parseInt(root.getAttribute('data-min'), 10) || 0;
    var variantId = root.getAttribute('data-variant');
    var cur = root.getAttribute('data-currency') || 'EUR';
    var picks = {};

    function money(c) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100);
      } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
    }

    function total() {
      return Object.keys(picks).reduce(function (n, k) { return n + picks[k].qty; }, 0);
    }

    function add(tile, delta) {
      var id = tile.getAttribute('data-id');
      if (!picks[id]) {
        picks[id] = { qty: 0, name: tile.getAttribute('data-name'), img: tile.getAttribute('data-img') };
      }
      picks[id].qty += delta;
      if (picks[id].qty <= 0) delete picks[id];
      render();
    }

    function render() {
      listEl.innerHTML = '';
      Object.keys(picks).forEach(function (id) {
        var p = picks[id];
        var li = document.createElement('li');
        li.className = 'sc-mix__row';
        li.innerHTML = '<img src="' + p.img + '" alt=""><span class="sc-mix__row-name">' + p.name + '</span>';
        var step = document.createElement('div');
        step.className = 'sc-mix__step';
        var minus = document.createElement('button');
        minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'One fewer ' + p.name);
        var n = document.createElement('span'); n.textContent = p.qty;
        var plus = document.createElement('button');
        plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'One more ' + p.name);
        minus.addEventListener('click', function () { bump(id, -1); });
        plus.addEventListener('click', function () { bump(id, 1); });
        step.appendChild(minus); step.appendChild(n); step.appendChild(plus);
        li.appendChild(step);
        listEl.appendChild(li);
      });

      var t = total();
      if (emptyEl) emptyEl.hidden = t > 0;
      if (countEl) countEl.textContent = t + (t === 1 ? ' piece' : ' pieces');
      if (priceEl) priceEl.textContent = money(t * unit);
      if (meterEl) {
        var pct = minP ? Math.min(100, (t / minP) * 100) : 100;
        meterEl.style.width = pct + '%';
        meterEl.classList.toggle('is-done', t >= minP);
      }
      if (noteEl) {
        noteEl.textContent = t >= minP ? 'Packed by hand in Sweden.' : (minP - t) + ' more to reach the ' + minP + '-piece minimum.';
      }
      if (addBtn) addBtn.disabled = t < minP || t === 0;

      [].slice.call(shelf.querySelectorAll('[data-id]')).forEach(function (tile) {
        var badge = tile.querySelector('[data-have]');
        var p = picks[tile.getAttribute('data-id')];
        if (!badge) return;
        badge.textContent = p ? p.qty : '';
        badge.hidden = !p;
      });
    }

    function bump(id, d) {
      if (!picks[id]) return;
      picks[id].qty += d;
      if (picks[id].qty <= 0) delete picks[id];
      render();
    }

    [].slice.call(shelf.querySelectorAll('[data-id]')).forEach(function (tile) {
      tile.addEventListener('click', function () { add(tile, 1); });
      tile.addEventListener('dragstart', function (e) {
        tile.classList.add('is-dragging');
        e.dataTransfer.setData('text/plain', tile.getAttribute('data-id'));
        e.dataTransfer.effectAllowed = 'copy';
      });
      tile.addEventListener('dragend', function () { tile.classList.remove('is-dragging'); });
    });

    bag.addEventListener('dragover', function (e) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; bag.classList.add('is-over'); });
    bag.addEventListener('dragleave', function () { bag.classList.remove('is-over'); });
    bag.addEventListener('drop', function (e) {
      e.preventDefault();
      bag.classList.remove('is-over');
      var id = e.dataTransfer.getData('text/plain');
      var tile = shelf.querySelector('[data-id="' + id + '"]');
      if (tile) add(tile, 1);
    });

    var head = bag.querySelector('[data-toggle]');
    if (head) head.addEventListener('click', function () { bag.classList.toggle('is-open'); });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var t = total();
        if (!t || !variantId) return;
        var contents = Object.keys(picks).map(function (k) { return picks[k].qty + ' x ' + picks[k].name; }).join(', ');
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: t, properties: { Contents: contents } })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || 'Could not add');
            window.location.href = '/cart';
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add mix to bag';
            if (noteEl) noteEl.textContent = err.message;
          });
      });
    }

    render();
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-mix]')).forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
